var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.classes),function(ref){
var color = ref[0];
var background = ref[1];
var fontSize = ref[2];
return _c('div',{key:color},[_c('div',[_c('v-btn',{class:[color, background, fontSize],style:({
        width: _vm.width ? _vm.width : 'unset',
        height: '38px',
      }),attrs:{"small":"","loading":_vm.loading,"depressed":_vm.depressed,"outline":_vm.outline},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+"\n    ")])],1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d67c6db8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Button.vue
// module id = null
// module chunks = 